import { useCallback, useMemo, useState } from "react";

export type AssetOption = { plantId?: string; plantName?: string; [key: string]: unknown };
export type EquipmentOption = { equipmentId?: string; equipmentName?: string; [key: string]: unknown };

const useSearchFilters = () => {
  const [searchString, setSearchString] = useState<string>('');
  const [selectedAssets, setSelectedAssets] = useState<AssetOption[]>([]);
  const [selectedEquipments, setSelectedEquipments] = useState<EquipmentOption[]>([]);

  const handleSearch = useCallback((value: string) => {
    setSearchString(value);
  }, []);

  const handleAssetSelect = useCallback((value: any) => {
    if (!value) {
      setSelectedAssets([]);
      return;
    }
    const options = Array.isArray(value) ? value : [value];
    setSelectedAssets(options.filter((v): v is AssetOption => v != null && v?.plantId != null));
  }, []);

  const handleEquipmentSelect = useCallback((value: any) => {
    if (!value) {
      setSelectedEquipments([]);
      return;
    }
    const options = Array.isArray(value) ? value : [value];
    setSelectedEquipments(options.filter((v): v is EquipmentOption => v != null && v?.equipmentId != null));
  }, []);

  const selectedAssetIds = useMemo(
    () => selectedAssets.map((a) => a.plantId).filter(Boolean) as string[],
    [selectedAssets]
  );

  const selectedEquipmentIds = useMemo(
    () => selectedEquipments.map((e) => e.equipmentId).filter(Boolean) as string[],
    [selectedEquipments]
  );

  return {
    searchString,
    handleSearch,
    selectedAssets,
    selectedAssetIds,
    handleAssetSelect,
    selectedEquipments,
    selectedEquipmentIds,
    handleEquipmentSelect,
  };
};

export default useSearchFilters;